import {
  LoginScreen,
  View,
  Page,
  LoginScreenTitle,
  List,
  ListItem,
  Label,
  Input,
  Button,
  Block,
} from "framework7-react";
import * as React from "react";
import { API_URL, CLOUD_FUNCTION } from "src/utils/constants";
import { api, getToken } from "src/utils/utils";
import { setToken } from "../../utils/utils";
import { IAuthData } from "../../utils/interfaces";

export default class LoginPage extends React.Component {
  public state = {
    user: "" as string,
    password: "" as string,
  };

  constructor(props: {} | Readonly<{}>) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
  }

  public async submitForm(event: React.FormEvent<HTMLElement>) {
    this.$f7?.input.validateInputs("#login-form");
    if (this.$$) {
      const isValid = this.$$("#login-form .input-invalid").length;

      if (!isValid) {
        const dialog = this.$f7?.dialog.preloader("Iniciando sesión");

        const authUser = await api.post<IAuthData[]>(
          API_URL + CLOUD_FUNCTION + "auth",
          this.state
        );

        if (authUser.length) {
          dialog?.close();
          this.$f7?.toast
            .create({
              text: "Bienvenido " + authUser[0].name,
              position: "bottom",
              closeTimeout: 2500,
            })
            .open();

          setToken(authUser[0]);

          const loginPageDialog = document.querySelector(
            "#login-screen"
          ) as HTMLElement;

          this.$f7?.loginScreen.close(loginPageDialog);
        } else {
          setTimeout(() => {
            dialog?.close();
            this.$f7?.toast
              .create({
                text: "Contraseña Incorrecta",
                position: "center",
                closeTimeout: 2000,
              })
              .open();
          }, 2000);
        }
      }
    }
  }

  public render() {
    return (
      <LoginScreen
        id="login-screen"
        className="center-login"
        opened={getToken() == null ? true : false}
      >
        <View>
          <Page loginScreen>
            <LoginScreenTitle>ANALYZER</LoginScreenTitle>
            <List form id="login-form">
              <ListItem>
                <Label>Usuario</Label>
                <Input
                  onChange={(e: any) =>
                    this.setState({
                      user: e.target.value,
                    })
                  }
                  required={true}
                  validate
                  clearButton
                  placeholder="Ingresa tu Usuario"
                  type="text"
                />
              </ListItem>
              <ListItem>
                <Label>Contraseña</Label>
                <Input
                  onChange={(e: any) =>
                    this.setState({
                      password: e.target.value,
                    })
                  }
                  type="password"
                  placeholder="Ingresa tu Contraseña"
                  required={true}
                  validate
                  clearButton
                />
              </ListItem>
            </List>
            <List>
              <Block>
                <Button
                  text="INICIAR SESIÓN"
                  type="submit"
                  fill
                  onClick={this.submitForm}
                />
              </Block>
            </List>
          </Page>
        </View>
      </LoginScreen>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/LoginPage.tsx